import * as React from "react";
import { Tabs } from "antd";
import Box from "@mui/material/Box";
import IntangibleAssetReport from "../Intangible Asset Report/AssetReport";
import IntangibleAssetSummaryReport from "../Intangible Asset Summary Report/AssetSumReport";
import IntangibleScheduleReport from "../Intangible Schedule Report/AssetSumReport";
import IntangibleDisposalAssetReport from "../Intangible Asset Disposal Report/AssetSumReport";
import IntangibleAssetRevaluationReport from "../Intangible Asset Revalutation Report/AssetRevaluationReport";
import IntangibleExhaustedAssetReport from "../Intangible Exhausted Asset Report/ExhaustedAssetReport";
import BranchesIntangibleAssetSummaryReport from "../BranchesIntangibleSummaryReport/BranchesIntangibleSummary";

import "./style.scss";

import { Helmet } from "react-helmet-async";

export default function IntangibleReport() {
  const items = [
    { key: "1", label: "Asset Report", children: <IntangibleAssetReport /> },
    {
      key: "2",
      label: "Summary Report",
      children: <IntangibleAssetSummaryReport />,
    },
    {
      key: "3",
      label: "Locations Report",
      children: <BranchesIntangibleAssetSummaryReport />,
    },
    {
      key: "4",
      label: "Schedule Report",
      children: <IntangibleScheduleReport />,
    },
    {
      key: "5",
      label: "Disposal Report",
      children: <IntangibleDisposalAssetReport />,
    },
    {
      key: "6",
      label: "Revaluation Report",
      children: <IntangibleAssetRevaluationReport />,
    },
    {
      key: "7",
      label: "Exhausted Report",
      children: <IntangibleExhaustedAssetReport />,
    },
  ];

  return (
    <Box sx={{}}>
      <Helmet title='Intangible Assets Report | Assets Register' />
      <Box elevation={24} sx={{ bgcolor: "#fff", width: "100%" }}></Box>
      <Tabs items={items} type='card' defaultActiveKey={"1"} />
    </Box>
  );
}
